var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.864,
    height: 21.681,
    viewBox: "0 0 17.864 21.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22198",
    "data-name": "Group 22198",
    transform: "translate(-0.73 -0.73)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22193",
    "data-name": "Group 22193",
    transform: "translate(1.48 1.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24700",
    "data-name": "Path 24700",
    d: "M18.364,10.178c0,4.384-3.886,8.767-6.3,11.069a2.72,2.72,0,0,1-3.759,0C5.886,18.945,2,14.561,2,10.178a8.182,8.182,0,0,1,16.364,0Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_273",
    "data-name": "Ellipse 273",
    cx: 3.727,
    cy: 3.727,
    r: 3.727,
    transform: "translate(4.455 4.762)",
    fill: "none",
    stroke: "#44546f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.46f637c80ea2860fce250d2867d087a4.svg";
export { ForwardRef as ReactComponent };